import Button from '@material-ui/core/Button/Button';
import Grid, { GridSize } from '@material-ui/core/Grid/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import AcceptTerms from 'components/AcceptTerms';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import Coupon from 'components/Cart/Coupon';
import CouponPrice from 'components/Cart/Coupon/CouponPrice';
import FeeInstallments from 'components/Cart/Footer/feeInstallment';
import FeeSubscription from 'components/Cart/Footer/feeSubscription';
import Payment from 'components/Cart/MainForm/Payment';
import CpfForm from 'components/Cart/MainForm/Payment/PaymentForm/CpfForm';
import PaymentButton from 'components/Cart/PaymentButton';
import QuantityForm from 'components/Cart/Physical/QuantityForm';
import PreviousStep from 'components/Cart/PreviousStep';
import Price, { enLayout } from 'components/Cart/Price';
import MultipleInstallments from 'components/Cart/Price/MultipleInstallments';
import { Subscription } from 'components/Cart/Price/Subscription';
import WithoutInstallment from 'components/Cart/Price/WithoutInstallment';
import { FieldValidation } from 'components/Field';
import Translate from 'components/Translate';
import { enPaymentType } from 'enums/enPaymentType';
import { IPaymentModel } from 'interfaces/IPaymentModel';
import { IProductData, IProductConfig, enCurrency } from 'interfaces/IProductData';
import get from 'lodash/get';
import React from 'react';
import { cartService } from 'services/CartService';
import { paymentService } from 'services/PaymentService';
import { MAX_CREDIT_CARDS } from 'settings';

import { IStepProps } from '.';
import { ICartModel } from 'interfaces/ICartModel';
import { SvgIcon } from 'components/SvgIcon';
import OrderBump from '../../../OrderBump';
import OpenValue from 'components/Cart/OpenValue';
import Next from 'components/Cart/Next';
import Summary from 'components/Cart/Summary';
import FreeShipping from 'components/Cart/Price/FreeShipping';
import { currencyService } from 'services/CurrencyService';
import HeaderTitle from './HeaderTitle';

interface IState extends IStateBase {
  cart: IProductData;
  model: ICartModel;
  showMessage: boolean;
  snackMessage: string;
  payment: ICartModel;
  paymentMethod: IPaymentModel;
  messageButton: string;
  showPaymentMultipleCardsButton: boolean;
  gridSize: GridSize[];
  currency: enCurrency;
}

export interface IProps extends IStepProps {
  onPay: () => void;
  step: number;
}

export default class StepPayment extends BaseComponent<IState, IProps> {
  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
    this.observeState({ payment: null }, paymentService.getCart());
    this.observeState({ showPaymentMultipleCardsButton: false }, paymentService.showPaymentMultipleCardsButton());
    this.observeState({ currency: enCurrency.BRL }, currencyService.getCurrency());
    this.bindModel(paymentService.getCart());

    this.setState({
      gridSize: [7, 5]
    });

    cartService
      .getCart()
      .take(1)
      .subscribe(cart => {
        if (cart.config.paymentType === enPaymentType.SUBSCRIPTION) {
          this.setState({
            gridSize: [4, 8]
          });
        }
      });

    paymentService
      .getCart()
      .combineLatest(cartService.getCart(), cartService.getConfig())
      .bindComponent(this)
      .subscribe(([payment, cart, config]) => {
        this.changeMessageButton(cart, payment, config);
      });
  }

  onValidate(errors: any) {
    this.setState({ validation: errors || {} });
  }

  isValid(): boolean {
    const validation = this.state.validation || {};
    return Object.keys(validation).length === 0;
  }

  finish = async () => {
    if (await this.isFormValid()) {
      this.props.onPay();
    }
  };

  addCreditCard = () => {
    paymentService
      .addPayment()
      .loader()
      .bindComponent(this)
      .take(1)
      .subscribe(() => {
        this.setState({
          showMessage: true,
          snackMessage: 'Um novo cartão foi adicionado'
        });
      });
  };

  showAddCardButton() {
    const isMultipleCreditCards = this.state.cart.config.multipleCreditCards;
    const canAddCreditCard = this.state.model.payment.length < MAX_CREDIT_CARDS && this.state.model.payment.length > 1;

    return isMultipleCreditCards && canAddCreditCard;
  }

  handleClose = () => {
    this.setState({
      showMessage: false
    });
  };

  removeCreditCard = () => {
    this.setState({
      showMessage: true,
      snackMessage: 'O cartão foi removido'
    });
  };

  changeMessageButton = (cart: IProductData, payment: ICartModel, config: IProductConfig) => {
    if (cart.config.paymentType == enPaymentType.FREE) {
      this.setState({ messageButton: 'Obter Gratuitamente' });
      return;
    }

    if (cart.config.paymentType == enPaymentType.SUBSCRIPTION) {
      this.setState({ messageButton: 'Assinar Plano' });
      return;
    }

    if (cart.config.paymentType == enPaymentType.DONATION) {
      this.setState({ messageButton: 'Finalizar' });
      return;
    }

    if (payment.payment[0].paymentMethod == null) {
      const messageButton = get(config, 'template.styles.buttons.text', 'Pagar e Receber Agora');
      messageButton ? this.setState({ messageButton }) : this.setState({ messageButton: 'Pagar e Receber Agora' });
    } else {
      switch (payment.payment[0].paymentMethod) {
        case 'boleto':
          this.setState({ messageButton: 'Gerar Boleto' });
          break;
        case 'paypal':
          this.setState({ messageButton: 'Ir para o PayPal' });
          break;

        default:
          const messageButton = get(config, 'template.styles.buttons.text', 'Pagar e Receber Agora');
          messageButton ? this.setState({ messageButton }) : this.setState({ messageButton: 'Pagar e Receber Agora' });
      }
    }
  };

  render() {
    if (!this.state || !this.state.cart) {
      return '';
    }

    const { model, cart, currency, payment, formSubmitted, messageButton, showPaymentMultipleCardsButton, gridSize } = this.state;
    const disabledButton = !this.isValid() && formSubmitted;
    const numberInstallments = payment.payment[0].numberInstallments;

    return (
      <div>
        <div className="step">
          <FieldValidation.Provider value={this.registerFields}>
            <Grid className="grid" container>
              <HeaderTitle shouldRenderModal={true} />
              <Grid item xs={12}>
                <Price layout={enLayout.column} cart={cart} hideMultipleInstallments={numberInstallments <= 1} />
              </Grid>

              <Grid container direction="row" alignItems="center" justify="space-between" spacing={1} className="chk-stepPayment__priceHeader">
                <Grid item xs={cart.config.paymentType !== enPaymentType.DONATION ? gridSize[0] : 12}>
                  <PreviousStep step={this.props.step} setStep={this.props.setStep} />
                  <OpenValue />
                  <Coupon />
                </Grid>

                <Grid item xs={gridSize[1]} className="chk-stepPayment__productPrice">
                  {cart.config.paymentType !== enPaymentType.DONATION && <CouponPrice />}

                  {cart.config.paymentType == enPaymentType.FREE && cart.config.paymentType == enPaymentType.FREE ? (
                    <Translate term={'Gratuito'} />
                  ) : null}

                  {[enPaymentType.NORMAL, enPaymentType.ECOMMERCE].includes(cart.config.paymentType) &&
                  cart.config.paymentType !== enPaymentType.DONATION ? (
                    cart.installments.length > 1 && payment.payment.length == 1 && currency === enCurrency.BRL ? (
                      <MultipleInstallments cart={cart} />
                    ) : (
                      <WithoutInstallment cart={cart} />
                    )
                  ) : null}

                  <FreeShipping config={cart.config} />

                  {cart.config.paymentType === enPaymentType.SUBSCRIPTION ? <Subscription cart={cart} /> : null}
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Next />
              </Grid>
              {cart.pins && (
                <div className="chk-stepPayment__pin">
                  <QuantityForm isPin={!!cart.pins} />
                </div>
              )}

              <Grid item xs={12}>
                {showPaymentMultipleCardsButton ? (
                  <div className="chk-multiple-cards">
                    <Button id="chk-init-multiplecards-button" className={'chk-add-credit-card theme-button'} onClick={this.addCreditCard}>
                      <SvgIcon name="multipleCards" />
                      <Translate term="Pagar com mais cartões?" />
                    </Button>
                  </div>
                ) : null}
              </Grid>

              {model.payment.map((model, key) => (
                <Payment key={key} index={key} cardFlagLimit={6} hidePaymentMessage={true} removeCreditCard={this.removeCreditCard} />
              ))}

              <Grid item xs={12}>
                {this.showAddCardButton() ? (
                  <div className="chk-multiple-cards">
                    <Button id="chk-add-multiplecard-button" className={'chk-add-credit-card theme-button'} onClick={this.addCreditCard}>
                      <SvgIcon name="multipleCards" />
                      <Translate term="Adicionar cartão de pagamento" />
                    </Button>
                  </div>
                ) : (
                  ''
                )}
              </Grid>

              <Grid className={`${cart.config.paymentType == enPaymentType.SUBSCRIPTION ? '' : 'cpf-form'}`} item xs={12}>
                <CpfForm />
              </Grid>

              {cart.config.paymentType == enPaymentType.SUBSCRIPTION ? (
                <Grid className="accept-terms" item xs={12}>
                  <AcceptTerms />
                </Grid>
              ) : null}

              <Grid item xs={12} className="chk-order-bump">
                <OrderBump />
              </Grid>

              <Summary />

              <PaymentButton finish={this.finish} disabledButton={disabledButton} messageButton={messageButton} />

              <div className="chk-stepPayment__feeInstallments">
                <FeeInstallments />
                {cart.config.paymentType === enPaymentType.SUBSCRIPTION ? <FeeSubscription /> : null}
              </div>
            </Grid>

            <Snackbar
              id="chk-cardmessage"
              className={'card-message'}
              open={this.state.showMessage}
              onClose={this.handleClose}
              autoHideDuration={1000}
              message={<span>{this.state.snackMessage}</span>}
            />
          </FieldValidation.Provider>
        </div>
      </div>
    );
  }
}
